"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./Contact.css");

var _react = _interopRequireDefault(require("react"));

var _Mouseflow = _interopRequireDefault(require("../../shared/components/Mouseflow"));

var _MarketingPageContent = _interopRequireDefault(require("../components/MarketingPageContent"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PropulatedView = _interopRequireDefault(require("../../higher-order/PropulatedView"));

var _ContentItem = _interopRequireDefault(require("../../shared/components/cms/ContentItem"));

var _ContactStore = _interopRequireDefault(require("../models/ContactStore"));

var _EmployeeSignup = _interopRequireDefault(require("../components/EmployeeSignup"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Contact = /*#__PURE__*/function (_React$Component) {
  _inherits(Contact, _React$Component);

  var _super = _createSuper(Contact);

  function Contact() {
    _classCallCheck(this, Contact);

    return _super.apply(this, arguments);
  }

  _createClass(Contact, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _Mouseflow.default)();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          contactMediaEmail = _this$props.contactMediaEmail,
          generalSalesEmail = _this$props.generalSalesEmail;
      return /*#__PURE__*/_react.default.createElement(_MarketingPageContent.default, null, /*#__PURE__*/_react.default.createElement("img", {
        alt: "background",
        src: require("../assets/redesign2020/contact/chevron_1.svg"),
        className: "contact-background-image-1"
      }), /*#__PURE__*/_react.default.createElement("img", {
        alt: "background",
        src: require("../assets/redesign2020/contact/chevron_2.svg"),
        className: "contact-background-image-2"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "contact-page"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: "contact-header"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "Contact"), " us"), /*#__PURE__*/_react.default.createElement("div", {
        className: "contact-body"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "contact-header-location"
      }, "LOCATION"), /*#__PURE__*/_react.default.createElement("address", {
        className: "contact-address"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "span",
        contentKey: "address1_v2"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "span",
        contentKey: "address2_v2"
      })), /*#__PURE__*/_react.default.createElement("h2", {
        className: "contact-header-sales"
      }, "GENERAL CONTACT & SALES"), /*#__PURE__*/_react.default.createElement("a", {
        className: "contact-sales-email",
        href: "mailto:".concat(generalSalesEmail)
      }, generalSalesEmail), /*#__PURE__*/_react.default.createElement("h2", {
        className: "contact-header-media"
      }, "MEDIA INQUIRIES"), /*#__PURE__*/_react.default.createElement("a", {
        className: "contact-media-email",
        href: "mailto:".concat(contactMediaEmail)
      }, contactMediaEmail)), /*#__PURE__*/_react.default.createElement(_EmployeeSignup.default, null)));
    }
  }]);

  return Contact;
}(_react.default.Component);

_defineProperty(Contact, "propTypes", {
  contactMediaEmail: _propTypes.default.string,
  generalSalesEmail: _propTypes.default.string
});

var _default = (0, _PropulatedView.default)(Contact, _ContactStore.default, ["contactMediaEmail", "generalSalesEmail"]);

exports.default = _default;